export class ViwAclrrModel {
  codAclrr:	string
  desAdc:	string
  desArea: string
  flgDelete: boolean
  idAclrr: number
  idArea:	number
  numFdv:	number
  uuid:	string
}